import React, { useEffect, useState } from 'react'
import Domande from './Domande'

const Gruppo = ({ gruppo, risposte, onChangeInputNumber, onChangeInputRadio, onChangeInputText, onChangeSelect, onChangeInputCheckbox }) => {

  const [visibile, mostra] = useState(false)

  useEffect(() => {
    // Mostro il gruppo solo se le domande contenute sono visualizzate in base ai riferimenti
    let _visibile = false;
    gruppo.domande.forEach(item => {
      const mostraSe = item.ARR_RIFERIMENTI;
      if (mostraSe.length === 0) {
        _visibile = true;
      } else {
        Object.keys(mostraSe).forEach(idx => {
          const domanda_rif = mostraSe[idx];
          if (risposte.indexOf(domanda_rif.ID_MA_CSS_D_R) >= 0) {
            _visibile = true;
          }
        })
      }
    });
    mostra(_visibile);
  }, [gruppo.domande, risposte])

  return (
    <>
      {visibile && (
        <div className="mb-3 form-group">
          <div className="form-control p-4 bg-white " style={{ border: "1px solid lightgrey", borderRadius: "10px" }}>
            <h4 className="text-uppercase" dangerouslySetInnerHTML={{ __html: gruppo.titolo }} />
            <p style={{ fontSize: "1rem" }}>{gruppo.descrizione}</p>
            <Domande domande={gruppo.domande}
              risposte={risposte}
              onChangeInputNumber={onChangeInputNumber}
              onChangeInputRadio={onChangeInputRadio}
              onChangeInputCheckbox={onChangeInputCheckbox}
              onChangeInputText={onChangeInputText}
              onChangeSelect={onChangeSelect}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default Gruppo